module.exports = __webpack_public_path__ + "img/126-a8d4ba.png";